import { render, staticRenderFns } from "./PlanSidebar.vue?vue&type=template&id=45a38225&"
import script from "./PlanSidebar.vue?vue&type=script&lang=js&"
export * from "./PlanSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PlanSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports